import type { ComponentProps } from 'react'
import { ROLE_PIECES, type WebModule } from '../core/index.js'
import { WorkerSearchPage } from './admin/WorkerSearchPage.js'
import { ROSTER_HELP_TOPICS } from './help.js'

/** What the roster module contributes to the shells: the admin's worker search across every client. */
export const rosterWebModule: WebModule<ComponentProps<typeof WorkerSearchPage>['api']> = {
  name: 'roster',
  adminPages: [{ path: '/admin/workers', label: 'Workers', title: 'Find a Worker', icon: ROLE_PIECES.worker, group: 'directory', page: ({ api }) => <WorkerSearchPage api={api} /> }],
  helpTopics: ROSTER_HELP_TOPICS,
}
